module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-plus-gray-dark-90d2d84576d4cc49fa044902b4661dca.svg";